import MUIDialogTitle, {
  type DialogTitleProps as MuiDialogTitleProps,
} from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';

import { CloseRoundedIcon } from '../icons';

interface DialogTitleProps extends MuiDialogTitleProps {
  onClose?: () => void;
  closeIcon?: JSX.Element;
  loading?: boolean;
}

export function DialogTitle(props: Readonly<DialogTitleProps>) {
  const { onClose, closeIcon, loading: isLoading, ...restProps } = props;

  if (onClose) {
    return (
      <>
        <MUIDialogTitle {...restProps} />
        <IconButton
          onClick={onClose}
          type='button'
          disabled={isLoading}
          sx={(theme) => ({
            position: 'absolute',
            right: theme.spacing(6),
            top: theme.spacing(6),
          })}
        >
          {closeIcon ?? <CloseRoundedIcon />}
        </IconButton>
      </>
    );
  }
  return <MUIDialogTitle {...props} />;
}
